var map = {
	"./card-list/card-list.vue": "bd61",
	"./kanji-card/kanji-card.vue": "3178",
	"./layout/app-sidebar.vue": "adb4",
	"./meaning-list/meaning-list.vue": "c145",
	"./meta-list/meta-list.vue": "084c",
	"./niai-search/niai-search.vue": "bf98",
	"./recent-changes/recent-changes.vue": "677e",
	"./svgs/svg-bars.vue": "4bb5",
	"./svgs/svg-clock.vue": "5f24",
	"./svgs/svg-close-circle.vue": "1a8b",
	"./svgs/svg-close.vue": "442f",
	"./svgs/svg-external-link.vue": "13d1",
	"./svgs/svg-github.vue": "e6c0",
	"./svgs/svg-moon.vue": "c7b4",
	"./svgs/svg-school.vue": "d002",
	"./svgs/svg-search.vue": "e7b4",
	"./svgs/svg-spinner.vue": "8bec",
	"./svgs/svg-sun.vue": "918c",
	"./vocab-card/vocab-card.vue": "1b85",
	"./vocab-card/vocab-contextual-meaning.vue": "844a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4daf";